module.exports = __webpack_public_path__ + "static/little-one-01-4cc7010759e51166a7a11cf840111617.png";